import * as React from "react"
import { connect } from "react-redux"
import trans from "trans";
import { AxiosResponse } from "axios";

import _find from "lodash/find";
import store from "store";

import { ID, ReduxList } from "app/types/app-types";
import { createToast } from "actions";
import { textToast } from "app/helpers/toast_factory";
import { URL } from "app/config/api-config";

import {
    Spinner,
    Message,
    css,
    Button,
    modal,
    LittleStatus,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit";

import {
    checkAllPredefinedExists, getAllFIEQueries, getQueries, toggleActiveFIEQuery,
} from "app/helpers/api";

import { Query } from "app/types/model-types"
import { setActiveFIEQueryId, setFIEQueriesToStore } from "../reducer";
import CreatePredefinedCheckboxes from "./create-predefined-checkboxes";
import { RouterType, withRouter } from "app/components/routes";
import { FIEQueryType } from "./fie-queries";
import { IconLightBulb } from "app/icons";
import { setQueriesToStore } from "actions";

export type PredefinedQueryType = {
    name: string
    element: string
}

interface Props {
    printExisting?: boolean
    router: RouterType
    setActiveFIEQueryId: typeof setActiveFIEQueryId
    setQueriesToStore: typeof setQueriesToStore
    setFIEQueriesToStore: typeof setFIEQueriesToStore
    activeFIEQueryId: ID
    fieQueries: ReduxList<FIEQueryType[]>
    queries: ReduxList<Query[]>

}

interface State {
    allPredefinedExists: boolean
    allPredefined: PredefinedQueryType[]
}

class CreatePredefinedQueries extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            allPredefinedExists: null,
            allPredefined: null,
        }
    }

    componentDidMount() {
        getAllFIEQueries()
            .then((response: AxiosResponse<FIEQueryType[]>) => {
                this.props.setFIEQueriesToStore(response.data)
            })
        .catch((e) => console.error('cannot get fie queries', e))

        this.checkPredefined()

        getQueries()
            .then((response: AxiosResponse<Query[]>) => {
                this.props.setQueriesToStore(response.data)
            })
            .catch(error => {
                console.error('error while getting queries', error)
            })
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && JSON.stringify(prevProps.fieQueries.data) !== JSON.stringify(this.props.fieQueries.data)) {
            this.checkPredefined()
        }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.error('predefined queries error', error)
    }

    close = () => {
        this.props.setActiveFIEQueryId(null)
    }

    checkPredefined = () => {
        checkAllPredefinedExists()
            .then((response: AxiosResponse<any>) => {
                this.setState({
                    allPredefinedExists: response.data.all_exists,
                    allPredefined: response.data.all_predefined,
                })
            })
            .catch((error) => {
                console.error('cannot check predefined queries', error)
            })
    }

    showModal = () => {
        const { allPredefined } = this.state
        const { fieQueries } = this.props

        {
            allPredefined &&
                modal({
                    overlayClassName: 'create-predefined-fie-queries',
                    title: trans("create_predefined_fie_queries_title"),
                    message: (close) => <CreatePredefinedCheckboxes fieQueries={fieQueries.data} allPredefined={allPredefined} setFIEQueriesToStore={this.props.setFIEQueriesToStore} close={close} />,
                    buttons: []
                })
        }
    }

    handleToggleActive = (fieQueryId) => {
        toggleActiveFIEQuery(fieQueryId)
            .then((response: AxiosResponse<FIEQueryType[]>) => {
                this.props.setFIEQueriesToStore(response.data)
            })
            .catch(error => {
                if (error.response && error.response.status === 409 && error.response.data.error) {
                    const message = `${trans(error.response.data.error)} (${error.response.data.template_ids.join(',')})`
                    store.dispatch(createToast(textToast('error', message)))
                } else {
                    console.error('cannot toggle active fie query', error)
                }
            })
    }

    render() {
        const { queries, fieQueries, printExisting } = this.props
        const { allPredefinedExists } = this.state

        if (!fieQueries.isLoaded || !queries.isLoaded) {
            return <Spinner type={'bubbles'} />
        }

        if (allPredefinedExists) {
            return <div />
        }

        const activeAndApplied = queries.data   /* "FIE_QUERY_WHITE = 1" */
            .filter(query => query.query && typeof query.query === "string" && query.query.length > 8 && query.query !== 'FIE_HIDE = 1' && `${query.query}`.startsWith('FIE_') && `${query.query}`.endsWith(' = 1'))
            .map(query => `${query.query}`.substring(0, query.query.length - 4))

        const fieQueriesNotAppliedYet = fieQueries.data
            .filter(fieQuery => fieQuery.is_active)
            .filter(fieQuery => !activeAndApplied.includes(fieQuery.element))

        const fieQueriesInactive = fieQueries.data.filter(fieQuery => !fieQuery.is_active)

        return (
            <Grid cols={'1fr'} style={{ marginBottom: '30px' }}>
                {printExisting && fieQueries &&
                    <React.Fragment>
                        {fieQueriesNotAppliedYet.length > 0 &&
                            <GridCell>
                                <StyledTitle>{trans('warn_rules_not_applied_yet')}</StyledTitle>

                                {fieQueriesNotAppliedYet.map((fieQuery) =>
                                    <React.Fragment key={`fie_query_${fieQuery.id}`}>
                                        <PrintFIEQuery fieQuery={fieQuery} keySuffix={'not_applied'} handleToggleActive={this.handleToggleActive} />
                                    </React.Fragment>
                                )}
                            </GridCell>
                        }

                        {fieQueriesInactive.length > 0 &&
                            <GridCell>
                                <StyledTitle>{trans('warn_inactive_fie_queries')}</StyledTitle>

                                {fieQueriesInactive.map((fieQuery) =>
                                    <React.Fragment key={`fie_query_${fieQuery.id}`}>
                                        <PrintFIEQuery fieQuery={fieQuery} keySuffix={'inactive'} handleToggleActive={this.handleToggleActive} />
                                    </React.Fragment>
                                )}
                            </GridCell>
                        }
                    </React.Fragment>
                }

                <Message type={"warning"} closeable={false} icon={<IconLightBulb size={24} />} style={{ borderColor: '#e0bf00' }}>
                    {trans("create_predefined_fie_queries_text")}
                    <Button type="void" color={"nocolor"} onClick={(e) => this.showModal()}>{trans("create")}</Button>
                </Message>
            </Grid>
        )
    }
}

const StyledButton = css(Button)({
    padding: '2px 8px',
})

const StyledTitle = css('div')({
    marginTop: '30px',
    background: '#009ba9',
    color: '#fff',
    padding: '8px',
})

const PrintFIEQuery = ({ fieQuery, handleToggleActive, keySuffix }) => <div key={`fie_query_${fieQuery.id}_${keySuffix}`} style={{ padding: '6px' }}>
    <LittleStatus
        type={fieQuery.is_active ? 'success' : 'warning'}
    ><strong> {fieQuery.name} </strong> <code>{fieQuery.element}</code></LittleStatus>
    <StyledButton
        type="void"
        color={"nocolor"}
        onClick={() => handleToggleActive(fieQuery.id)}
    >{trans(fieQuery.is_active ? "set_inactive" : "set_active")}</StyledButton>
</div>

function mapStateToProps(state) {
    return {
        activeFIEQueryId: state.activeFIEQueryId,
        fieQueries: state.fieQueries,
        queries: state.queries,
    }
}

export default connect(mapStateToProps, {
    setActiveFIEQueryId,
    setFIEQueriesToStore,
    setQueriesToStore,
})(withRouter(CreatePredefinedQueries))